import styled from "styled-components";
import { Button } from "../../globalStyles";

export const HeroSection = styled.section`
  height: 100vh;
  background-position: center;
  background-size: cover;
  box-shadow: inset 0 0 0 1000px rgba(0, 0, 0, 0.2);
`;

export const HeroContent = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`;

export const HeroVideo = styled.video`
  object-fit: cover;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.1));
  top: 0;
  position: absolute;
  z-index: -1;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;

export const HeroBackground = styled.div`
  object-fit: cover;
  width: 100%;
  height: 100%;
  background: url(${({ src }) => (src ? src : '')});
  top: 0;
  position: absolute;
  z-index: -1;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;

export const HeroText = styled.p`
  margin-bottom: 35px;
  font-size: clamp(0.7rem, 2vh, 1.5rem);
  font-weight: 300;
  font-style: italic;
  line-height: clamp(1.5rem, 3vh, 2.5rem);
  text-align: left;
  letter-spacing: 2px;
  color: #fff;
`;
export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-flow: wrap;
  gap: 0.5rem;
`;

export const HeroButton = styled(Button)`
  color: black;

  &:before {
    background: #fff;
    height: 500%;
  }

  &:hover:before {
    height: 0%;
  }

  &:hover {
    color: white;
  }
`;